/* =========================================================
   P2P - Step 1: Upload  |  Section JavaScript
   window.P2PStep1Config is injected by the Liquid template
   ========================================================= */

(function () {
  'use strict';

  var config = window.P2PStep1Config || {};
  var thumbImages = config.thumbImages || [];
  var UPLOAD_REDIRECT_URL = config.uploadRedirectUrl || 'https://prompt2prints.com/pages/photo-to-canvas-customize?data=true';
  var UPLOAD_LINK_STORAGE_KEY = 'pdpUploadedImage';
  var UPLOAD_LINK_COOKIE_KEYS = ['pdpUploadedImage', 'p2pUploadedImage'];
  var ORIGINAL_LINK_STORAGE_KEY = 'pdpOriginalImage';
  var ORIGINAL_LINK_COOKIE_KEYS = ['pdpOriginalImage', 'p2pOriginalImage'];
  var AI_PREFERENCES_STORAGE_KEY = 'p2p_ai_generation_preferences';
  var AI_PROMPT_STORAGE_KEY = 'p2p_ai_prompt';
  var AI_SELECTED_STYLE_STORAGE_KEY = 'p2p_selected_style';
  var AI_STYLE_API_STORAGE_KEY = 'p2p_ai_style_api_name';
  var AI_FLOW_CHOICE_STORAGE_KEY = 'p2p_flow_choice';

  var AI_DIMENSION_META = {
    square: { portrait: '1:1', landscape: '1:1' },
    poster: { portrait: '2:3', landscape: '3:2' },
    classic: { portrait: '3:4', landscape: '4:3' },
    standard: { portrait: '4:5', landscape: '5:4' },
    'print-friendly': { portrait: '5:7', landscape: '7:5' },
    panorama: { portrait: '1:2', landscape: '2:1' }
  };

  var aiStyleMeta = {};

  var MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB
  var ACCEPTED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'heic', 'heif'];
  var ACCEPTED_MIME_TYPES = {
    'image/png': true,
    'image/jpg': true,
    'image/jpeg': true,
    'image/heic': true,
    'image/heif': true
  };

  var currentThumb = 0;
  var selected = null;
  var currentUpload = null;
  var dragDepth = 0;
  var isSubmittingUpload = false;
  var isAiGenerating = false;
  var lastGeneratedImageUrl = null;
  var hasScrolledToGeneratedResult = false;
  var STICKY_NAV_SCROLL_OFFSET = 126;
  var aiFlowState = {
    isOpen: false,
    currentStep: 1,
    orientation: 'portrait',
    dimension: 'square',
    style: 'impasto-oil',
    realism: true,
    prompt: ''
  };

  document.addEventListener('DOMContentLoaded', function () {
    /* Prevent stale uploads from enabling Continue on first load. */
    clearPersistedUploadData();
    currentUpload = null;

    // var counter = document.getElementById('imgCounter');
    // if (counter && thumbImages.length > 0) {
    //   counter.textContent = '1 / ' + thumbImages.length;
    // }

    initUploadInteractions();
    initAiQuestionFlow();
    syncUploadUI();
    setUploadCtaState();

     // Auto-select option based on URL query parameter "mode"
    var urlParams = new URLSearchParams(window.location.search);
    var mode = urlParams.get('mode');
    if (mode === 'upload') {
        setTimeout(function() {
    
      selectOption('upload');
     
     
    }, 0);
  } else if (mode === 'generate') {
    setTimeout(function() {
      selectOption('ai');
     
    }, 0);
  }
  });

  function buildRedirectUrl(baseUrl) {
    if (!baseUrl) {
      return '';
    }

    if (typeof URL === 'undefined' || typeof URLSearchParams === 'undefined') {
      return String(baseUrl);
    }

    var target;
    try {
      target = new URL(baseUrl, window.location && window.location.origin ? window.location.origin : undefined);
    } catch (error) {
      return String(baseUrl);
    }

    var current;
    try {
      current = new URL(window.location.href);
    } catch (error) {
      current = null;
    }

    if (current) {
      var currentParams = new URLSearchParams(current.search || '');
      var targetParams = new URLSearchParams(target.search || '');

      currentParams.forEach(function (value, key) {
        if (key === 'data') {
          return;
        }

        var existingValues = targetParams.getAll(key);
        if (existingValues && existingValues.indexOf(value) !== -1) {
          return;
        }

        targetParams.append(key, value);
      });

      targetParams.set('data', 'true');
      var nextQuery = targetParams.toString();
      target.search = nextQuery ? '?' + nextQuery : '';
    }

    return target.toString();
  }

  function isMobileViewport() {
    try {
      return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    } catch (error) {
      return window.innerWidth <= 768;
    }
  }

  function scrollToPageTopOfElement(target, options) {
    options = options || {};
    var el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) {
      return;
    }

    var offset = typeof options.offset === 'number' ? options.offset : 10;
    var behavior = options.behavior || 'smooth';
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };

    /* Wait for layout/visibility updates before computing position (iOS friendly). */
    raf(function () {
      raf(function () {
        var rect = el.getBoundingClientRect();
        var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var top = rect.top + currentY - offset;
        if (top < 0) {
          top = 0;
        }

        try {
          window.scrollTo({ top: top, left: 0, behavior: behavior });
        } catch (error) {
          window.scrollTo(0, top);
        }
      });
    });
  }

  function scrollAiQuestionTop() {
    if (!isMobileViewport()) {
      return;
    }

    var els = getAiFlowElements();
    if (!els.questionFlow || !els.questionFlow.classList.contains('show')) {
      return;
    }

    var activeStep = document.querySelector('[data-ai-flow-step].is-active');
    var target = (activeStep && activeStep.querySelector('.ai-question-card')) || els.questionFlow;
    scrollToPageTopOfElement(target, { offset: STICKY_NAV_SCROLL_OFFSET });
  }

  function scrollGeneratedPreviewTop() {
    if (!isMobileViewport()) {
      return;
    }

    var col = getGalleryCol();
    if (!col) {
      return;
    }

    var target =
      col.querySelector('.gallery-gen-result') ||
      col.querySelector('.gallery-gen-overlay') ||
      col;

    scrollToPageTopOfElement(target, { offset: STICKY_NAV_SCROLL_OFFSET });
  }

  function getUploadElements() {
    return {
      uploadZone: document.getElementById('uploadZone'),
      uploadBrowseButton: document.getElementById('uploadBrowseButton'),
      uploadFeedback: document.getElementById('uploadFeedback'),
      uploadedPreview: document.getElementById('uploadedPreview'),
      previewImg: document.getElementById('previewImg'),
      uploadedFileName: document.getElementById('uploadedFileName'),
      uploadedFileStatus: document.getElementById('uploadedFileStatus'),
      fileInput: document.getElementById('fileInput'),
      uploadCta: document.getElementById('uploadCta')
    };
  }

  function getAiFlowElements() {
    return {
      startFlow: document.getElementById('step1StartFlow'),
      questionFlow: document.getElementById('aiQuestionFlow'),
      flowFooter: document.getElementById('aiFlowFooter'),
      flowSteps: document.querySelectorAll('[data-ai-flow-step]'),
      dimensionGrid: document.getElementById('aiDimensionGrid'),
      styleGrid: document.getElementById('aiStyleGrid'),
      backBtn: document.getElementById('aiFlowBackBtn'),
      nextBtn: document.getElementById('aiFlowNextBtn'),
      generateBtn: document.getElementById('aiGenerateBtn'),
      realismToggle: document.getElementById('aiRealismToggle'),
      dimensionSummary: document.getElementById('aiDimensionSummary'),
      styleSummary: document.getElementById('aiStyleSummary'),
      promptTextarea: document.getElementById('aiPromptTextarea'),
      orientationTabs: document.querySelectorAll('[data-ai-orientation]'),
      dimensionCards: document.querySelectorAll('[data-ai-dimension]'),
      styleCards: document.querySelectorAll('[data-ai-style]')
    };
  }

  function normalizeAiStyleValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildAiStyleMeta(styleCards) {
    var meta = {};

    styleCards.forEach(function (card) {
      var key = card.getAttribute('data-ai-style');
      if (!key) {
        return;
      }

      meta[key] = {
        key: key,
        label: card.getAttribute('data-ai-style-label') || key,
        apiName: (card.getAttribute('data-ai-style-api') || '').trim(),
        selectionValue: key === 'none' ? '' : (card.getAttribute('data-ai-style-label') || key)
      };
    });

    return meta;
  }

  function getDefaultAiStyleKey() {
    var keys = Object.keys(aiStyleMeta);
    var firstNonNone = '';

    keys.forEach(function (key) {
      if (!firstNonNone && key !== 'none') {
        firstNonNone = key;
      }
    });

    return firstNonNone || (keys.length ? keys[0] : 'none');
  }

  function syncAiStyleMeta(styleCards) {
    aiStyleMeta = buildAiStyleMeta(styleCards || []);

    if (!Object.keys(aiStyleMeta).length) {
      aiStyleMeta.none = {
        key: 'none',
        label: 'None',
        apiName: '',
        selectionValue: ''
      };
    }

    if (!aiStyleMeta[aiFlowState.style]) {
      aiFlowState.style = getDefaultAiStyleKey();
    }
  }

  function getAiStyleMetaEntry(style) {
    return aiStyleMeta[style] || null;
  }

  function resolveAiStyleKey(style, apiName, label) {
    var directCandidates = [style, apiName];
    var normalizedCandidates = [style, apiName, label].map(normalizeAiStyleValue).filter(Boolean);
    var keys = Object.keys(aiStyleMeta);
    var match = '';

    directCandidates.forEach(function (candidate) {
      if (!match && candidate && aiStyleMeta[candidate]) {
        match = candidate;
      }
    });

    if (match) {
      return match;
    }

    keys.forEach(function (key) {
      var entry = aiStyleMeta[key];
      var entryValues = [
        normalizeAiStyleValue(key),
        normalizeAiStyleValue(entry && entry.apiName),
        normalizeAiStyleValue(entry && entry.label)
      ];

      normalizedCandidates.forEach(function (candidate) {
        if (!match && candidate && entryValues.indexOf(candidate) !== -1) {
          match = key;
        }
      });
    });

    return match;
  }

  function initUploadInteractions() {
    var els = getUploadElements();

    if (!els.uploadZone || !els.fileInput) {
      return;
    }

    els.uploadZone.addEventListener('click', function () {
      openFilePicker();
    });

    els.uploadZone.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openFilePicker();
      }
    });

    if (els.uploadBrowseButton) {
      els.uploadBrowseButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openFilePicker();
      });
    }

    els.fileInput.addEventListener('change', handleFileSelect);
    els.uploadZone.addEventListener('dragenter', handleDragEnter);
    els.uploadZone.addEventListener('dragover', handleDragOver);
    els.uploadZone.addEventListener('dragleave', handleDragLeave);
    els.uploadZone.addEventListener('drop', handleDrop);
  }

  function initAiQuestionFlow() {
    var els = getAiFlowElements();

    if (!els.questionFlow) {
      return;
    }

    syncAiStyleMeta(els.styleCards);
    restoreAiPreferences();
    syncAiPromptFromStorage();

    /* Browsers can restore their own textarea session-cache AFTER JS runs,
       blanking what we just set. Re-apply the saved prompt one tick later
       to guarantee our value wins regardless of browser form restoration. */
    if (aiFlowState.prompt) {
      var restoredPrompt = aiFlowState.prompt;
      setTimeout(function () {
        var textarea = document.getElementById('aiPromptTextarea');
        if (textarea && textarea.value !== restoredPrompt) {
          textarea.value = restoredPrompt;
        }
      }, 0);
    }

    els.orientationTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setAiOrientation(tab.getAttribute('data-ai-orientation'));
      });
    });

    els.dimensionCards.forEach(function (card) {
      card.addEventListener('click', function () {
        setAiDimension(card.getAttribute('data-ai-dimension'));
      });
    });

    els.styleCards.forEach(function (card) {
      card.addEventListener('click', function () {
        setAiStyle(card.getAttribute('data-ai-style'));
      });
    });

    if (els.backBtn) {
      els.backBtn.addEventListener('click', handleAiFlowBack);
    }

    if (els.nextBtn) {
      els.nextBtn.addEventListener('click', handleCTA1Next);
    }

    if (els.generateBtn) {
      els.generateBtn.addEventListener('click', handleAiGenerate);
    }

    if (els.realismToggle) {
      els.realismToggle.addEventListener('click', toggleAiRealism);
    }

    var helpTrigger = document.getElementById('realismHelpTrigger');
    if (helpTrigger) {
      helpTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        helpTrigger.classList.toggle('is-open');
      });
      helpTrigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          helpTrigger.classList.toggle('is-open');
        }
        if (e.key === 'Escape') {
          helpTrigger.classList.remove('is-open');
        }
      });
      document.addEventListener('click', function (e) {
        if (!helpTrigger.contains(e.target)) {
          helpTrigger.classList.remove('is-open');
        }
      });
    }

    if (els.promptTextarea) {
      els.promptTextarea.addEventListener('input', function () {
        updateAiPrompt(els.promptTextarea.value || '');
      });
    }

    applyAiFlowState();
    toggleAiQuestionFlow(false);
    initStepPopupChips();
  }

  function restoreAiPreferences() {
    try {
      var saved = localStorage.getItem(AI_PREFERENCES_STORAGE_KEY);
      if (!saved) {
        return;
      }

      var parsed = JSON.parse(saved);
      if (!parsed) {
        return;
      }

      if (parsed.orientation === 'landscape') {
        aiFlowState.orientation = 'landscape';
      }

      if (parsed.dimension && AI_DIMENSION_META[parsed.dimension]) {
        aiFlowState.dimension = parsed.dimension;
      }

      var resolvedStyle = resolveAiStyleKey(parsed.style, parsed.styleApiName, parsed.styleLabel);
      if (resolvedStyle) {
        aiFlowState.style = resolvedStyle;
      }

      if (typeof parsed.realism === 'boolean') {
        aiFlowState.realism = parsed.realism;
      }

      if (typeof parsed.prompt === 'string') {
        aiFlowState.prompt = parsed.prompt;
      }
    } catch (error) {}
  }

  function syncAiPromptFromStorage() {
    try {
      var savedPrompt = localStorage.getItem(AI_PROMPT_STORAGE_KEY);
      if (savedPrompt && !aiFlowState.prompt) {
        aiFlowState.prompt = savedPrompt;
      }
    } catch (error) {}

    /* Directly populate textarea in case applyAiFlowState runs before
       the element is ready or gets overwritten by browser form cache. */
    if (aiFlowState.prompt) {
      var textarea = document.getElementById('aiPromptTextarea');
      if (textarea && textarea.value !== aiFlowState.prompt) {
        textarea.value = aiFlowState.prompt;
      }
    }
  }

  function openAiQuestionFlow() {
    if (selected !== 'ai') {
      selectOption('ai');
    }

    aiFlowState.isOpen = true;
    aiFlowState.currentStep = 1;
    applyAiFlowState();
    toggleAiQuestionFlow(true);
    scrollAiQuestionTop();
  }

  function closeAiQuestionFlow() {
    aiFlowState.isOpen = false;
    aiFlowState.currentStep = 1;
    applyAiFlowState();
    toggleAiQuestionFlow(false);
  }

  function toggleAiQuestionFlow(isVisible) {
    var els = getAiFlowElements();

    if (els.startFlow) {
      els.startFlow.classList.toggle('is-hidden', isVisible);
    }

    if (els.questionFlow) {
      els.questionFlow.classList.toggle('show', isVisible);
      els.questionFlow.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }
  }

  function setAiFlowStep(step) {
    if (step < 1 || step > 3) {
      return;
    }

    aiFlowState.currentStep = step;
    applyAiFlowState();
    scrollAiQuestionTop();
  }

  function setAiOrientation(orientation) {
    if (orientation !== 'portrait' && orientation !== 'landscape') {
      return;
    }

    aiFlowState.orientation = orientation;
    applyAiFlowState();
    persistAiPreferences();
  }

  function setAiDimension(dimension) {
    if (!AI_DIMENSION_META[dimension]) {
      return;
    }

    aiFlowState.dimension = dimension;
    applyAiFlowState();
    persistAiPreferences();
  }

  function setAiStyle(style) {
    if (!getAiStyleMetaEntry(style)) {
      return;
    }

    aiFlowState.style = style;
    applyAiFlowState();
    persistAiPreferences();
  }

  function toggleAiRealism() {
    aiFlowState.realism = !aiFlowState.realism;
    applyAiFlowState();
    persistAiPreferences();
  }

  function updateAiPrompt(promptText) {
    aiFlowState.prompt = promptText;
    applyAiFlowState();
    persistAiPreferences();
  }

  function applyAiFlowState() {
    var els = getAiFlowElements();
    var step = aiFlowState.currentStep >= 1 && aiFlowState.currentStep <= 3 ? aiFlowState.currentStep : 1;
    var orientation = aiFlowState.orientation === 'landscape' ? 'landscape' : 'portrait';
    var ratio = getAiRatioForDimension(aiFlowState.dimension, orientation);
    var promptText = (aiFlowState.prompt || '').trim();

    els.flowSteps.forEach(function (panel) {
      var panelStep = Number(panel.getAttribute('data-ai-flow-step')) || 0;
      var isActive = panelStep === step;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    els.orientationTabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-ai-orientation') === orientation;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (els.dimensionGrid) {
      els.dimensionGrid.classList.toggle('is-landscape', orientation === 'landscape');
    }

    els.dimensionCards.forEach(function (card) {
      var dimension = card.getAttribute('data-ai-dimension');
      var ratioText = getAiRatioForDimension(dimension, orientation);
      var ratioNode = card.querySelector('.ai-dimension-card-ratio');
      var isSelected = aiFlowState.dimension === dimension;

      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

      if (ratioNode) {
        ratioNode.textContent = '(' + ratioText + ')';
      }
    });

    els.styleCards.forEach(function (card) {
      var isSelected = card.getAttribute('data-ai-style') === aiFlowState.style;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (els.promptTextarea && els.promptTextarea.value !== aiFlowState.prompt) {
      els.promptTextarea.value = aiFlowState.prompt;
    }

    if (els.dimensionSummary) {
      els.dimensionSummary.textContent = getAiDimensionSummaryText(aiFlowState.dimension, orientation, ratio);
    }

    if (els.styleSummary) {
      els.styleSummary.textContent = getAiStyleLabel(aiFlowState.style);
    }

    if (els.realismToggle) {
      els.realismToggle.classList.toggle('is-active', aiFlowState.realism);
      els.realismToggle.setAttribute('aria-checked', aiFlowState.realism ? 'true' : 'false');
    }

    if (els.flowFooter) {
      els.flowFooter.classList.toggle('is-final-step', step === 3);
      els.flowFooter.style.display = step === 3 ? 'none' : '';
    }

    if (els.nextBtn) {
      var isDisabled = step === 1 ? !aiFlowState.dimension : !aiFlowState.style;
      els.nextBtn.hidden = step === 3;
      els.nextBtn.disabled = isDisabled;
      els.nextBtn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    }

    if (els.generateBtn) {
      var canGenerate = !!aiFlowState.dimension && !!aiFlowState.style && !!promptText;
      els.generateBtn.disabled = !canGenerate;
      els.generateBtn.setAttribute('aria-disabled', canGenerate ? 'false' : 'true');
    }
  }

  function getAiRatioForDimension(dimension, orientation) {
    var dimensionMeta = AI_DIMENSION_META[dimension];
    if (!dimensionMeta) {
      return '1:1';
    }

    return dimensionMeta[orientation] || dimensionMeta.portrait || '1:1';
  }

  function getAiStyleApiName(style) {
    var entry = getAiStyleMetaEntry(style);
    return entry ? entry.apiName : '';
  }

  function getAiStyleLabel(style) {
    var entry = getAiStyleMetaEntry(style);
    return entry ? entry.label : 'None';
  }

  function getAiStyleSelectionValue(style) {
    var entry = getAiStyleMetaEntry(style);
    return entry ? entry.selectionValue : '';
  }

  function getAiDimensionSummaryText(dimension, orientation, ratio) {
    var parts = (dimension || 'square').split('-').map(function (part) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    });
    return parts.join(' ') + ' (' + ratio + ')';
  }

  function persistAiPreferences() {
    var promptText = (aiFlowState.prompt || '').trim();
    var selectedStyleLabel = getAiStyleSelectionValue(aiFlowState.style);
    var selectedStyleApiName = getAiStyleApiName(aiFlowState.style);

    try {
      localStorage.setItem(AI_PREFERENCES_STORAGE_KEY, JSON.stringify({
        orientation: aiFlowState.orientation,
        dimension: aiFlowState.dimension,
        ratio: getAiRatioForDimension(aiFlowState.dimension, aiFlowState.orientation),
        style: aiFlowState.style,
        styleLabel: getAiStyleLabel(aiFlowState.style),
        styleApiName: selectedStyleApiName,
        realism: aiFlowState.realism,
        prompt: promptText
      }));

      localStorage.setItem(AI_FLOW_CHOICE_STORAGE_KEY, 'ai');

      if (selectedStyleLabel) {
        localStorage.setItem(AI_SELECTED_STYLE_STORAGE_KEY, selectedStyleLabel);
      } else {
        localStorage.removeItem(AI_SELECTED_STYLE_STORAGE_KEY);
      }

      if (selectedStyleApiName) {
        localStorage.setItem(AI_STYLE_API_STORAGE_KEY, selectedStyleApiName);
      } else {
        localStorage.removeItem(AI_STYLE_API_STORAGE_KEY);
      }

      if (promptText) {
        localStorage.setItem(AI_PROMPT_STORAGE_KEY, promptText);
      } else {
        localStorage.removeItem(AI_PROMPT_STORAGE_KEY);
      }
    } catch (error) {}
  }

  /* gallery */
  function selectThumb(idx) {
    currentThumb = idx;
    var mainImg = document.getElementById('mainImg');
    if (mainImg && thumbImages[idx]) {
      mainImg.src = thumbImages[idx];
    }
    // var counter = document.getElementById('imgCounter');
    // if (counter) {
    //   counter.textContent = (idx + 1) + ' / ' + thumbImages.length;
    // }
    document.querySelectorAll('.thumb').forEach(function (t, i) {
      t.classList.toggle('active', i === idx);
    });
  }

  function selectStyle(el) {
    document.querySelectorAll('.style-pill').forEach(function (p) {
      p.classList.remove('active');
    });
    el.classList.add('active');
  }

  /* option cards */
  function selectOption(type, doScroll) {
    selected = type;

    var uploadCard = document.getElementById('uploadCard');
    var aiCard = document.getElementById('aiCard');
    var uploadCta = document.getElementById('uploadCta');
    var aiCta = document.getElementById('aiCta');
    var nav = document.getElementById('p2pNav');

    if (uploadCard) {
      uploadCard.classList.toggle('selected', type === 'upload');
    }
    if (aiCard) {
      aiCard.classList.toggle('selected', type === 'ai');
    }
    if (uploadCta) {
      uploadCta.style.display = type === 'upload' ? 'flex' : 'none';
    }
    if (aiCta) {
      aiCta.style.display = type === 'ai' ? 'flex' : 'none';
    }
    if (nav) {
      nav.dataset.navMode = type === 'ai' ? 'ai' : 'upload';
    }

    if (type !== 'ai') {
      aiFlowState.isOpen = false;
      toggleAiQuestionFlow(false);
    } else if (aiFlowState.isOpen) {
      toggleAiQuestionFlow(true);
    } else {
      toggleAiQuestionFlow(false);
    }

    syncUploadUI();
    setUploadCtaState();
  }

  function syncUploadUI() {
    var els = getUploadElements();
    var shouldShowUploadZone = selected === 'upload' && !hasUploadedPhoto();
    var shouldShowPreview = selected === 'upload' && hasUploadedPhoto();

    if (els.uploadZone) {
      els.uploadZone.classList.toggle('show', shouldShowUploadZone);
      els.uploadZone.classList.remove('drag-over');
      els.uploadZone.setAttribute('aria-hidden', shouldShowUploadZone ? 'false' : 'true');
    }

    if (els.uploadedPreview) {
      els.uploadedPreview.classList.toggle('show', shouldShowPreview);
    }

    syncMobileUploadCardLayout();
  }

  var uploadZoneGroupHome = null;
  var uploadCtaHome = null;

  function isMobileCardLayout() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 560px)').matches);
  }

  /* On mobile, the upload zone/preview (and its Get Started CTA) live inside
     the Upload Photo card, replacing its default content, instead of below
     both option cards. */
  function syncMobileUploadCardLayout() {
    var group = document.getElementById('uploadZoneGroup');
    var uploadCard = document.getElementById('uploadCard');
    var uploadCta = document.getElementById('uploadCta');
    if (!group || !uploadCard) {
      return;
    }

    if (!uploadZoneGroupHome) {
      uploadZoneGroupHome = { parent: group.parentNode, nextSibling: group.nextSibling };
    }
    if (uploadCta && !uploadCtaHome) {
      uploadCtaHome = { parent: uploadCta.parentNode, nextSibling: uploadCta.nextSibling };
    }

    var shouldEmbed = isMobileCardLayout() && selected === 'upload';

    if (shouldEmbed) {
      uploadCard.classList.add('mobile-dropzone-active');
      if (group.parentNode !== uploadCard) {
        uploadCard.appendChild(group);
      }
      if (uploadCta && uploadCta.parentNode !== uploadCard) {
        uploadCard.appendChild(uploadCta);
      }
    } else {
      uploadCard.classList.remove('mobile-dropzone-active');
      if (group.parentNode !== uploadZoneGroupHome.parent) {
        uploadZoneGroupHome.parent.insertBefore(group, uploadZoneGroupHome.nextSibling);
      }
      if (uploadCta && uploadCtaHome && uploadCta.parentNode !== uploadCtaHome.parent) {
        uploadCtaHome.parent.insertBefore(uploadCta, uploadCtaHome.nextSibling);
      }
    }
  }

  var mobileLayoutResizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(mobileLayoutResizeTimer);
    mobileLayoutResizeTimer = setTimeout(syncMobileUploadCardLayout, 150);
  });

  function hasUploadedPhoto() {
    return !!(currentUpload && currentUpload.dataUrl);
  }

  function getUploadedPhotoLink() {
    try {
      if (currentUpload && currentUpload.uploadedLink) {
        return currentUpload.uploadedLink;
      }
    } catch (error) {}

    try {
      return localStorage.getItem(UPLOAD_LINK_STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function hasUploadedPhotoLink() {
    return !!getUploadedPhotoLink();
  }

  function openFilePicker() {
    var els = getUploadElements();
    clearUploadFeedback();

    if (!els.fileInput) {
      return;
    }

    els.fileInput.value = '';
    els.fileInput.click();
  }

  /* drag & drop */
  function handleDragEnter(event) {
    event.preventDefault();
    event.stopPropagation();

    if (selected !== 'upload') {
      selectOption('upload', false);
    }

    dragDepth += 1;

    var uploadZone = document.getElementById('uploadZone');
    if (uploadZone) {
      uploadZone.classList.add('drag-over');
    }
  }

  function handleDragOver(event) {
    event.preventDefault();
    event.stopPropagation();

    if (selected !== 'upload') {
      selectOption('upload', false);
    }

    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }

    var uploadZone = document.getElementById('uploadZone');
    if (uploadZone) {
      uploadZone.classList.add('drag-over');
    }
  }

  function handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();

    dragDepth = Math.max(0, dragDepth - 1);

    if (dragDepth === 0) {
      var uploadZone = document.getElementById('uploadZone');
      if (uploadZone) {
        uploadZone.classList.remove('drag-over');
      }
    }
  }

  function handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();

    dragDepth = 0;

    var uploadZone = document.getElementById('uploadZone');
    if (uploadZone) {
      uploadZone.classList.remove('drag-over');
    }

    if (selected !== 'upload') {
      selectOption('upload');
    }

    var files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length > 0) {
      processSelectedFile(files[0]);
    }
  }

  /* file input */
  function handleFileSelect(event) {
    var files = event.target && event.target.files;

    if (selected !== 'upload') {
      selectOption('upload');
    }

    if (files && files.length > 0) {
      processSelectedFile(files[0]);
    }
  }

  async function processSelectedFile(file) {
    var validation = validateUploadFile(file);

    clearUploadFeedback();

    if (!validation.valid) {
      showUploadFeedback(validation.message, 'error');
      setUploadCtaState();
      return;
    }

    /* New selection invalidates any previously-uploaded link. */
    clearPersistedUploadData();

    setUploadProcessing(true, validation.isHeic ? 'Uploading...' : 'Uploading...');

    try {
      var processedFile = validation.isHeic ? await convertHeicToJpg(file) : file;
      var previewDataUrl = await readFileAsDataUrl(processedFile);

      currentUpload = {
        file: processedFile,
        dataUrl: previewDataUrl,
        fileName: getDisplayFileName(processedFile),
        uploadedLink: ''
      };

      updateUploadPreview();
      clearUploadFeedback();

      /* Upload immediately after the user selects a file. */
      await submitCurrentUpload();
    } catch (error) {
      console.error('Upload processing failed:', error);
      showUploadFeedback('We could not process that image. Please try PNG, JPG, JPEG, or another HEIC photo.', 'error');
    } finally {
      setUploadProcessing(false);
      syncUploadUI();
      setUploadCtaState();
    }
  }

  function validateUploadFile(file) {
    if (!file) {
      return {
        valid: false,
        message: 'Please choose a file to continue.'
      };
    }

    var mimeType = (file.type || '').toLowerCase();
    var extension = getFileExtension(file.name);
    var isHeic = mimeType === 'image/heic' ||
      mimeType === 'image/heif' ||
      extension === 'heic' ||
      extension === 'heif';
    var isAcceptedType = !!ACCEPTED_MIME_TYPES[mimeType] ||
      ACCEPTED_EXTENSIONS.indexOf(extension) !== -1;

    if (!isAcceptedType) {
      return {
        valid: false,
        message: 'Only PNG, JPG, JPEG, and HEIC files are supported.'
      };
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      return {
        valid: false,
        message: 'Your image exceeds the 20 MB limit. Please upload a smaller file.'
      };
    }

    return {
      valid: true,
      isHeic: isHeic
    };
  }

  async function convertHeicToJpg(file) {
    if (typeof window.heic2any !== 'function') {
      throw new Error('HEIC conversion library unavailable');
    }

    var converted = await window.heic2any({
      blob: file,
      toType: 'image/jpeg',
      quality: 0.92
    });

    var blob = Array.isArray(converted) ? converted[0] : converted;
    if (!(blob instanceof Blob)) {
      throw new Error('Unexpected HEIC conversion result');
    }

    var outputName = getConvertedFileName(file.name);

    try {
      var convertedFile = new File([blob], outputName, {
        type: 'image/jpeg',
        lastModified: Date.now()
      });
      convertedFile.convertedFromHeic = true;
      return convertedFile;
    } catch (error) {
      blob.name = outputName;
      blob.convertedFromHeic = true;
      return blob;
    }
  }

  function readFileAsDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onload = function (event) {
        resolve(event.target.result);
      };

      reader.onerror = function () {
        reject(new Error('Could not read the selected file.'));
      };

      reader.readAsDataURL(file);
    });
  }

  function getPrompt2PrintsConfig() {
    var prompt2Prints = window.Prompt2Prints || {};

    return {
      apiBase: prompt2Prints.apiBase || 'https://api.prompt2prints.com',
      apiKey: prompt2Prints.apiKey || ''
    };
  }

  function getCustomerId() {
    return config.customerId || window.shopifyCustomerId || 'guest';
  }

  function getSessionId() {
    try {
      if (typeof window.getLocalStorage1Day === 'function') {
        return window.getLocalStorage1Day('sessionId') || 'none';
      }

      var item = localStorage.getItem('sessionId');
      if (!item) {
        return 'none';
      }

      if (item.charAt(0) === '{' && item.indexOf('"expiry"') !== -1) {
        var parsedItem = JSON.parse(item);
        if (parsedItem.expiry && Date.now() > parsedItem.expiry) {
          localStorage.removeItem('sessionId');
          return 'none';
        }
        return parsedItem.value || 'none';
      }

      return item;
    } catch (error) {
      console.error('Unable to read sessionId:', error);
      return 'none';
    }
  }

  async function uploadImageToAPI(file) {
    var apiConfig = getPrompt2PrintsConfig();
    if (!apiConfig.apiKey) {
      throw new Error('Prompt2Prints API key is missing.');
    }

    var formData = new FormData();
    formData.append('file', file);
    formData.append('customerId', getCustomerId());
    formData.append('sessionId', getSessionId());
    formData.append('megamenu', 'true');

    var response = await fetch(apiConfig.apiBase + '/upload-image', {
      method: 'POST',
      headers: {
        'x-api-key': apiConfig.apiKey
      },
      body: formData
    });

    if (!response.ok) {
      var errorPayload = null;
      try {
        errorPayload = await response.json();
      } catch (e) {
        try {
          errorPayload = await response.text();
        } catch (e2) {}
      }

      try {
        var errMsg =
          (errorPayload && typeof errorPayload === 'object' && typeof errorPayload.error === 'string' && errorPayload.error) ||
          (errorPayload && typeof errorPayload === 'object' && typeof errorPayload.message === 'string' && errorPayload.message) ||
          (typeof errorPayload === 'string' ? errorPayload : '');

        if (
          (errorPayload && typeof errorPayload === 'object' &&
            errorPayload.error && typeof errorPayload.error === 'string' &&
            errorPayload.error.toLowerCase().includes('no more credits'))
          || (errMsg && errMsg.toLowerCase().indexOf('no more credits') !== -1)
        ) {
          if (typeof showNoCreditPopup === 'function') {
            showNoCreditPopup();
          } else if (window && typeof window.showNoCreditPopup === 'function') {
            window.showNoCreditPopup();
          }
        }
      } catch (e3) {}

      throw new Error('API Error: ' + response.status);
    }

    return response.json();
  }

  function setCookie(name, value, maxAgeSeconds) {
    if (!name) {
      return;
    }

    var cookieParts = [
      name + '=' + encodeURIComponent(value || ''),
      'path=/',
      'max-age=' + maxAgeSeconds,
      'SameSite=Lax'
    ];

    if (window.location && /(^|\.)prompt2prints\.com$/i.test(window.location.hostname)) {
      cookieParts.push('domain=.prompt2prints.com');
    }

    if (window.location && window.location.protocol === 'https:') {
      cookieParts.push('Secure');
    }

    document.cookie = cookieParts.join('; ');
  }

  function clearCookie(name) {
    if (!name) {
      return;
    }

    var cookieParts = [
      name + '=',
      'path=/',
      'expires=Thu, 01 Jan 1970 00:00:00 GMT',
      'SameSite=Lax'
    ];

    if (window.location && /(^|\.)prompt2prints\.com$/i.test(window.location.hostname)) {
      cookieParts.push('domain=.prompt2prints.com');
    }

    if (window.location && window.location.protocol === 'https:') {
      cookieParts.push('Secure');
    }

    document.cookie = cookieParts.join('; ');
  }

  function persistUploadedImageLink(link) {
    if (!link) {
      return;
    }

    try {
      localStorage.setItem(UPLOAD_LINK_STORAGE_KEY, link);
      localStorage.setItem(ORIGINAL_LINK_STORAGE_KEY, link);
    } catch (error) {
      console.error('Unable to store uploaded image link in localStorage:', error);
    }

    for (var i = 0; i < UPLOAD_LINK_COOKIE_KEYS.length; i += 1) {
      setCookie(UPLOAD_LINK_COOKIE_KEYS[i], link, 24 * 60 * 60);
    }

    for (var j = 0; j < ORIGINAL_LINK_COOKIE_KEYS.length; j += 1) {
      setCookie(ORIGINAL_LINK_COOKIE_KEYS[j], link, 24 * 60 * 60);
    }
  }

  function clearPersistedUploadData() {
    try {
      localStorage.removeItem('p2p_uploaded_image');
      localStorage.removeItem(UPLOAD_LINK_STORAGE_KEY);
      localStorage.removeItem(ORIGINAL_LINK_STORAGE_KEY);
    } catch (error) {}

    for (var i = 0; i < UPLOAD_LINK_COOKIE_KEYS.length; i += 1) {
      clearCookie(UPLOAD_LINK_COOKIE_KEYS[i]);
    }

    for (var j = 0; j < ORIGINAL_LINK_COOKIE_KEYS.length; j += 1) {
      clearCookie(ORIGINAL_LINK_COOKIE_KEYS[j]);
    }
  }

  function updateUploadPreview() {
    var els = getUploadElements();

    if (!currentUpload || !els.previewImg || !els.uploadedFileName || !els.uploadedFileStatus) {
      return;
    }

    els.previewImg.src = currentUpload.dataUrl;
    els.previewImg.alt = currentUpload.fileName + ' preview';
    els.uploadedFileName.textContent = currentUpload.fileName;
    els.uploadedFileStatus.innerHTML = '&#10003; Photo ready';
  }

  function setUploadFileStatus(html) {
    var els = getUploadElements();
    if (!els.uploadedFileStatus) {
      return;
    }

    els.uploadedFileStatus.innerHTML = html || '';
  }

  function setUploadThumbLoading(isLoading) {
    var overlay = document.getElementById('uploadThumbLoading');
    if (overlay) {
      overlay.hidden = !isLoading;
    }
  }

  async function submitCurrentUpload() {
    if (!currentUpload || !currentUpload.file) {
      return false;
    }

    if (isSubmittingUpload) {
      return false;
    }

    isSubmittingUpload = true;
    setUploadCtaState();
    setUploadThumbLoading(true);
    setUploadFileStatus('<span class=\"upload-spinner\"></span> Uploading...');

    try {
      var data = await uploadImageToAPI(currentUpload.file);
      if (!data || !data.cloudfrontLink) {
        throw new Error('cloudfrontLink not found in API response');
      }

      currentUpload.uploadedLink = data.cloudfrontLink;
      persistUploadedImageLink(data.cloudfrontLink);
      setUploadFileStatus('&#10003; Uploaded');
      showUploadFeedback('Upload complete. Click Continue to proceed.', 'success');
      return true;
    } catch (error) {
      console.error('Image upload API failed:', error);
      setUploadFileStatus('Upload failed');
      showUploadFeedback('Image upload failed. Please try again.', 'error');
      return false;
    } finally {
      isSubmittingUpload = false;
      setUploadThumbLoading(false);
      setUploadCtaState();
    }
  }

  function removeUpload() {
    var els = getUploadElements();

    currentUpload = null;
    dragDepth = 0;
    setUploadThumbLoading(false);

    if (els.previewImg) {
      els.previewImg.removeAttribute('src');
    }
    if (els.uploadedFileName) {
      els.uploadedFileName.textContent = 'Uploaded photo';
    }
    if (els.uploadedFileStatus) {
      els.uploadedFileStatus.innerHTML = '&#10003; Photo ready';
    }

    if (els.fileInput) {
      els.fileInput.value = '';
    }

    clearPersistedUploadData();

    clearUploadFeedback();
    syncUploadUI();
    setUploadCtaState();
  }

  function showUploadFeedback(message, type) {
    var feedback = document.getElementById('uploadFeedback');
    if (!feedback) {
      return;
    }

    feedback.textContent = message || '';
    feedback.classList.add('show');
    feedback.classList.remove('is-error', 'is-success');

    if (type === 'error') {
      feedback.classList.add('is-error');
    } else if (type === 'success') {
      feedback.classList.add('is-success');
    }
  }

  function clearUploadFeedback() {
    var feedback = document.getElementById('uploadFeedback');
    if (!feedback) {
      return;
    }

    feedback.textContent = '';
    feedback.classList.remove('show', 'is-error', 'is-success');
  }

  function setUploadProcessing(isProcessing, message) {
    var els = getUploadElements();
    if (!els.uploadZone) {
      return;
    }

    els.uploadZone.classList.toggle('is-processing', isProcessing);
    els.uploadZone.setAttribute('aria-busy', isProcessing ? 'true' : 'false');

    var loadingTextEl = document.getElementById('uploadZoneLoadingText');
    if (loadingTextEl && message) {
      loadingTextEl.textContent = message;
    }

    if (!isProcessing && !hasUploadedPhoto()) {
      clearUploadFeedback();
    }
  }

  function setUploadCtaState() {
    var els = getUploadElements();
    if (!els.uploadCta) {
      return;
    }

    var isProcessing = isSubmittingUpload ||
      !!(els.uploadZone && els.uploadZone.classList.contains('is-processing'));
    els.uploadCta.disabled = selected === 'upload' && (!hasUploadedPhotoLink() || isProcessing);
  }

  function getFileExtension(fileName) {
    var match = (fileName || '').toLowerCase().match(/\.([a-z0-9]+)$/);
    return match ? match[1] : '';
  }

  function getConvertedFileName(fileName) {
    if (!fileName) {
      return 'upload.jpg';
    }

    return fileName.replace(/\.(heic|heif)$/i, '.jpg');
  }

  function getDisplayFileName(file) {
    if (!file) {
      return 'Uploaded photo';
    }

    return file.name || 'Uploaded photo';
  }

  /* AI presets */
  function setPreset(el) {
    var ta = document.querySelector('.ai-textarea');
    if (!ta) {
      return;
    }

    ta.value = 'A ' + el.textContent.toLowerCase() +
      ' with expressive eyes, sitting regally in noble attire...';
    ta.focus();
  }

  /* CTA */
  async function handleCTA() {
    if (selected === 'upload') {
      if (!hasUploadedPhoto()) {
        showUploadFeedback('Please upload a PNG, JPG, JPEG, or HEIC image first.', 'error');
        syncUploadUI();
        setUploadCtaState();
        return;
      }

      if (isSubmittingUpload) {
        return;
      }

      var link = getUploadedPhotoLink();
      if (!link) {
        /* Fallback: user may click Continue before the auto-upload completes or after an error. */
        setUploadProcessing(true, 'Uploading your photo...');
        await submitCurrentUpload();
        setUploadProcessing(false);
        link = getUploadedPhotoLink();
      }

      if (!link) {
        showUploadFeedback('Image upload failed. Please try again.', 'error');
        return;
      }

      window.location.href = buildRedirectUrl(UPLOAD_REDIRECT_URL);
      return;
    }

    var url = config.uploadRedirectUrl;
    window.location.href = buildRedirectUrl(url);
  }

  function handleCTA1() {
    openAiQuestionFlow();
  }

  function handleAiFlowBack() {
    if (aiFlowState.currentStep > 1) {
      setAiFlowStep(aiFlowState.currentStep - 1);
      persistAiPreferences();
      return;
    }

    closeAiQuestionFlow();
  }

  function handleCTA1Next() {
    if (aiFlowState.currentStep === 1) {
      if (!aiFlowState.dimension) {
        return;
      }

      setAiFlowStep(2);
      persistAiPreferences();
      return;
    }

    if (aiFlowState.currentStep === 2) {
      if (!aiFlowState.style) {
        return;
      }

      setAiFlowStep(3);
      persistAiPreferences();
    }
  }

  function getGalleryCol() {
    return document.querySelector('.gallery-col');
  }

  function gallerySetOriginalVisible(visible) {
    var col = getGalleryCol();
    if (!col) { return; }
    var wrap   = document.getElementById('mainImgWrap');
    var thumbs = col.querySelector('.thumbs');
    var val    = visible ? '' : 'none';
    if (wrap)   { wrap.style.display   = val; }
    if (thumbs) { thumbs.style.display = val; }
  }

  function setGalleryGenerating(isGenerating) {
    var col = getGalleryCol();
    if (!col) { return; }

    /* clean up any previous run */
    hidePostGenerateActions();
    var old = col.querySelector('.gallery-gen-result, .gallery-gen-overlay');
    while (old) { old.remove(); old = col.querySelector('.gallery-gen-result, .gallery-gen-overlay'); }
    hasScrolledToGeneratedResult = false;

    if (isGenerating) {
      gallerySetOriginalVisible(false);

      var overlay = document.createElement('div');
      overlay.className = 'gallery-gen-overlay';
      overlay.innerHTML =
        '<div class="gallery-gen-inner">' +
          '<div class="gallery-gen-rings">' +
            '<div class="gallery-gen-ring gallery-gen-ring--1"></div>' +
            '<div class="gallery-gen-ring gallery-gen-ring--2"></div>' +
            '<div class="gallery-gen-ring gallery-gen-ring--3"></div>' +
            '<div class="gallery-gen-icon">' +
              '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(192,132,252,0.9)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M12 2L2 7l10 5 10-5-10-5z"/>' +
                '<path d="M2 17l10 5 10-5"/>' +
                '<path d="M2 12l10 5 10-5"/>' +
              '</svg>' +
            '</div>' +
          '</div>' +
          '<p class="gallery-gen-title">Generating...</p>' +
          '<p class="gallery-gen-sub">This usually takes 15–30 seconds</p>' +
        '</div>';
      col.appendChild(overlay);
    } else {
      /* error / cancelled — restore original */
      gallerySetOriginalVisible(true);
    }
  }

  function showGeneratedImage(src, isPreview) {
    if (!src) { return; }

    var col = getGalleryCol();
    if (!col) { return; }

    /* kill the loading overlay the moment first image arrives */
    var overlay = col.querySelector('.gallery-gen-overlay');
    if (overlay) { overlay.remove(); }

    /* build the result panel once */
    var result = col.querySelector('.gallery-gen-result');
    if (!result) {
      result = document.createElement('div');
      result.className = 'gallery-gen-result';
      result.innerHTML =
        '<img class="gallery-gen-img" alt="AI generated portrait">' +
        '<div class="gallery-preview-badge" style="display:none">' +
          '<span class="gallery-preview-dot"></span>Enhancing…' +
        '</div>' +
        '<div class="ai-gen-badge" style="display:none">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M12 2L2 7l10 5 10-5-10-5z"/>' +
            '<path d="M2 17l10 5 10-5"/>' +
            '<path d="M2 12l10 5 10-5"/>' +
          '</svg>AI Generated' +
        '</div>';
      col.appendChild(result);
    }

    /* set the image — always update src so final URL replaces preview */
    var img = result.querySelector('.gallery-gen-img');
    if (img) {
      img.style.transition = isPreview ? 'none' : 'filter 0.55s ease';
      img.style.filter     = isPreview ? 'blur(6px) saturate(0.5)' : 'none';
      img.src = src;           /* set AFTER style so browser doesn't flash */
    }

    if (!hasScrolledToGeneratedResult) {
      hasScrolledToGeneratedResult = true;
      scrollGeneratedPreviewTop();
    }

    /* badges */
    var prevBadge  = result.querySelector('.gallery-preview-badge');
    var finalBadge = result.querySelector('.ai-gen-badge');
    if (isPreview) {
      if (prevBadge)  { prevBadge.style.display  = 'flex'; }
      if (finalBadge) { finalBadge.style.display = 'none'; }
    } else {
      if (prevBadge)  { prevBadge.style.display  = 'none'; }
      if (finalBadge) { finalBadge.style.display = 'flex'; }
      lastGeneratedImageUrl = src;
      showPostGenerateActions(src);
    }
  }

  function showPostGenerateActions(imageUrl) {
    hidePostGenerateActions();

    var genBtn = document.getElementById('aiGenerateBtn');
    if (!genBtn) { return; }

    /* hide the Generate button; show our 2-button bar in its place */
    genBtn.style.display = 'none';

    var actions = document.createElement('div');
    actions.id = 'aiPostGenerateActions';
    actions.className = 'ai-post-generate-actions';

    var regenBtn = document.createElement('button');
    regenBtn.type = 'button';
    regenBtn.className = 'ai-post-btn ai-post-btn--regen';
    regenBtn.innerHTML =
      'Regenerate<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="1 4 1 10 7 10"/>' +
        '<path d="M3.51 15a9 9 0 1 0 .49-3.5"/>' +
      '</svg>';
    regenBtn.addEventListener('click', function () {
      handleAiGenerate();
    });

    var continueBtn = document.createElement('button');
    continueBtn.type = 'button';
    continueBtn.className = 'ai-post-btn ai-post-btn--continue';
    continueBtn.innerHTML =
      'Continue<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="9 18 15 12 9 6"/>' +
      '</svg>';
    continueBtn.addEventListener('click', function () {
      handleContinue(imageUrl);
    });

    actions.appendChild(regenBtn);
    actions.appendChild(continueBtn);

    /* insert right after the Generate button */
    genBtn.parentNode.insertBefore(actions, genBtn.nextSibling);

    showGalleryContinueBtn(imageUrl);
  }

  function showGalleryContinueBtn(imageUrl) {
    hideGalleryContinueBtn();

    var col = getGalleryCol();
    if (!col) { return; }

    var result = col.querySelector('.gallery-gen-result');
    if (!result) { return; }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'galleryContinueBtn';
    btn.className = 'gallery-gen-continue-btn';
    btn.innerHTML =
      'Continue' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M5 12h14"/><path d="M12 5l7 7-7 7"/>' +
      '</svg>';
    btn.addEventListener('click', function () {
      handleContinue(imageUrl);
    });

    result.parentNode.insertBefore(btn, result.nextSibling);
  }

  function hideGalleryContinueBtn() {
    var existing = document.getElementById('galleryContinueBtn');
    if (existing) { existing.parentNode.removeChild(existing); }
  }

  function hidePostGenerateActions() {
    var existing = document.getElementById('aiPostGenerateActions');
    if (existing) { existing.parentNode.removeChild(existing); }
    hideGalleryContinueBtn();
    var genBtn = document.getElementById('aiGenerateBtn');
    if (genBtn) { genBtn.style.display = ''; }
  }

  function handleContinue(imageUrl) {
    if (!imageUrl) { return; }
    persistUploadedImageLink(imageUrl);
    window.location.href = 'https://prompt2prints.com/products/canvas?syncMode=pdp-img&data=true';
  }

  function setGenerateBtnState(isGenerating) {
    var btn = document.getElementById('aiGenerateBtn');
    if (!btn) {
      return;
    }

    if (isGenerating) {
      btn.disabled = true;
      btn.innerHTML =
        '<span class="ai-btn-spinner"></span>Generating…';
    } else {
      btn.disabled = false;
      btn.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M12 2L2 7l10 5 10-5-10-5z"/>' +
          '<path d="M2 17l10 5 10-5"/>' +
          '<path d="M2 12l10 5 10-5"/>' +
        '</svg>Generate Image';
    }
  }

  function handleAiGenerate() {
    var promptText = (aiFlowState.prompt || '').trim();
    if (!aiFlowState.dimension || !aiFlowState.style || !promptText) {
      return;
    }
    if (isAiGenerating) {
      return;
    }

    persistAiPreferences();

    var apiConfig = getPrompt2PrintsConfig();
    if (!apiConfig.apiKey) {
      console.error('Prompt2Prints API key is missing.');
      return;
    }

    var styleApiName = getAiStyleApiName(aiFlowState.style);
    var ratio = getAiRatioForDimension(aiFlowState.dimension, aiFlowState.orientation);
    var customerId = getCustomerId();
    var sessionId = getSessionId();

    var paramsObj = {
      prompt: promptText,
      orientation: aiFlowState.orientation,
      outputFormat: 'jpeg',
      sessionId: sessionId
    };

    if (styleApiName) {
      paramsObj.style = styleApiName;
    }
    if (ratio) {
      paramsObj.aspect_ratio = ratio;
    }
    if (customerId && customerId !== 'guest') {
      paramsObj.customerId = customerId;
    }
    paramsObj.apiKey = apiConfig.apiKey;
    paramsObj.page_url = window.location.href;

    var params = new URLSearchParams(paramsObj);
    var url = apiConfig.apiBase + '/text-to-image?' + params.toString();

    isAiGenerating = true;
    setGalleryGenerating(true);
    setGenerateBtnState(true);
    scrollGeneratedPreviewTop();

    var imageQueue = [];
    var isDone = false;

    /* drain queue every 100 ms; self-clears only after done AND empty */
    var displayInterval = setInterval(function () {
      if (imageQueue.length > 0) {
        var item = imageQueue.shift();
        showGeneratedImage(item.src, item.isPreview);
      } else if (isDone) {
        clearInterval(displayInterval);
        var col = getGalleryCol();
        if (col && !col.querySelector('.gallery-gen-result')) {
          setGalleryGenerating(false);
        }
        isAiGenerating = false;
        setGenerateBtnState(false);
      }
    }, 100);

    function onStreamError() {
      isDone = true;
      clearInterval(displayInterval);
      isAiGenerating = false;
      setGalleryGenerating(false);
      setGenerateBtnState(false);
    }

    /* Use fetch + ReadableStream so we bypass the MIME-type check that
       EventSource enforces — the server sends SSE data but with the wrong
       Content-Type header (application/json instead of text/event-stream). */
    fetch(url)
      .then(function (response) {
        function triggerNoCreditsPopup() {
          try {
            if (typeof showNoCreditPopup === 'function') {
              showNoCreditPopup();
              return;
            }
          } catch (e) {}

          try {
            if (window && typeof window.showNoCreditPopup === 'function') {
              window.showNoCreditPopup();
            }
          } catch (e) {}
        }

        function hasNoMoreCredits(payload) {
          if (!payload) {
            return false;
          }

          if (typeof payload === 'object' && typeof payload.error === 'string') {
            try {
              if (payload.error && payload.error.toLowerCase().includes('no more credits')) {
                return true;
              }
            } catch (e) {}
          }

          var msg = '';
          if (typeof payload === 'string') {
            msg = payload;
          } else if (typeof payload === 'object') {
            msg =
              (typeof payload.error === 'string' && payload.error) ||
              (typeof payload.message === 'string' && payload.message) ||
              (typeof payload.detail === 'string' && payload.detail) ||
              '';
          }

          return !!(msg && msg.toLowerCase().indexOf('no more credits') !== -1);
        }

        var contentType = '';
        try {
          contentType = (response.headers.get('content-type') || '').toLowerCase();
        } catch (e) {}

        if (!response.ok) {
          return response.text().then(function (text) {
            if (hasNoMoreCredits(text)) {
              triggerNoCreditsPopup();
            }
            onStreamError();
          }).catch(function () {
            onStreamError();
          });
        }

        if (contentType.indexOf('application/json') !== -1) {
          return response.json().then(function (data) {
            if (hasNoMoreCredits(data)) {
              triggerNoCreditsPopup();
            }
            onStreamError();
          }).catch(function () {
            onStreamError();
          });
        }

        if (!response.body) {
          onStreamError();
          return;
        }

        var reader  = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer  = '';
        var evtName = '';
        var evtData = '';

        function processLine(line) {
          line = line.replace(/\r$/, '');
          if (line === '') {
            /* blank line = dispatch accumulated event */
            if (evtName === 'image' && evtData) {
              try {
                var d   = JSON.parse(evtData);
                var src = d.url || d.base64Image;
                if (src) { imageQueue.push({ src: src, isPreview: !!d.preview }); }
              } catch (e) { /* ignore malformed */ }
            } else if (evtName === 'error' && evtData) {
              try {
                var errPayload = JSON.parse(evtData);
                if (hasNoMoreCredits(errPayload)) {
                  triggerNoCreditsPopup();
                }
              } catch (e) {
                if (hasNoMoreCredits(evtData)) {
                  triggerNoCreditsPopup();
                }
              }
              isDone = true;
            } else if (evtName === 'done') {
              isDone = true;
            }
            evtName = '';
            evtData = '';
          } else if (line.indexOf('event:') === 0) {
            evtName = line.slice(6).trim();
          } else if (line.indexOf('data:') === 0) {
            evtData = line.slice(5).trim();
          }
        }

        function pump() {
          return reader.read().then(function (chunk) {
            if (chunk.done) {
              /* flush any remaining buffer */
              if (buffer) { processLine(buffer); buffer = ''; }
              isDone = true;
              return;
            }
            buffer += decoder.decode(chunk.value, { stream: true });
            var lines = buffer.split('\n');
            buffer = lines.pop(); /* last incomplete line stays in buffer */
            for (var i = 0; i < lines.length; i++) { processLine(lines[i]); }
            return pump();
          });
        }

      fetchCredits();
        return pump();
        
      })
      .catch(function (err) {
        console.error('Stream fetch failed:', err);
        onStreamError();
      });
  }

  /* ── AI Step Popup (edit dimension/style from Step 3 summary chips) ── */
  var aiPopupType = null;

  function getOrCreatePopupEl() {
    var existing = document.getElementById('aiStepPopup');
    if (existing) {
      return existing;
    }

    var popup = document.createElement('div');
    popup.id = 'aiStepPopup';
    popup.className = 'ai-step-popup';
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.innerHTML =
      '<div class="ai-step-popup__backdrop"></div>' +
      '<div class="ai-step-popup__card">' +
        '<button class="ai-step-popup__close" type="button" aria-label="Close">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M18 6L6 18"/><path d="M6 6l12 12"/>' +
          '</svg>' +
        '</button>' +
        '<div class="ai-step-popup__content"></div>' +
      '</div>';

    document.body.appendChild(popup);

    popup.querySelector('.ai-step-popup__close').addEventListener('click', closeStepPopup);
    popup.querySelector('.ai-step-popup__backdrop').addEventListener('click', closeStepPopup);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeStepPopup();
      }
    });

    return popup;
  }

  function openStepPopup(type) {
    var stepNum = type === 'dimension' ? 1 : 2;
    var sourceStep = document.querySelector('[data-ai-flow-step="' + stepNum + '"]');
    if (!sourceStep) {
      return;
    }

    var questionCard = sourceStep.querySelector('.ai-question-card');
    if (!questionCard) {
      return;
    }

    var popup = getOrCreatePopupEl();
    var content = popup.querySelector('.ai-step-popup__content');
    if (!content) {
      return;
    }

    content.innerHTML = '';
    content.appendChild(questionCard.cloneNode(true));

    applyStateToPopupContent(content, type);
    wirePopupEvents(content, type);

    aiPopupType = type;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeStepPopup() {
    var popup = document.getElementById('aiStepPopup');
    if (!popup || !popup.classList.contains('is-open')) {
      return;
    }

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    aiPopupType = null;
  }

  function applyStateToPopupContent(contentEl, type) {
    var orientation = aiFlowState.orientation;

    if (type === 'dimension') {
      contentEl.querySelectorAll('[data-ai-orientation]').forEach(function (tab) {
        var isActive = tab.getAttribute('data-ai-orientation') === orientation;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      var dimGrid = contentEl.querySelector('.ai-dimension-grid');
      if (dimGrid) {
        dimGrid.classList.toggle('is-landscape', orientation === 'landscape');
      }

      contentEl.querySelectorAll('[data-ai-dimension]').forEach(function (card) {
        var dimension = card.getAttribute('data-ai-dimension');
        var ratioText = getAiRatioForDimension(dimension, orientation);
        var ratioNode = card.querySelector('.ai-dimension-card-ratio');
        var isSelected = aiFlowState.dimension === dimension;

        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        if (ratioNode) {
          ratioNode.textContent = '(' + ratioText + ')';
        }
      });
    }

    if (type === 'style') {
      contentEl.querySelectorAll('[data-ai-style]').forEach(function (card) {
        var isSelected = card.getAttribute('data-ai-style') === aiFlowState.style;
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }
  }

  function wirePopupEvents(contentEl, type) {
    if (type === 'dimension') {
      contentEl.querySelectorAll('[data-ai-orientation]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          setAiOrientation(tab.getAttribute('data-ai-orientation'));
          applyStateToPopupContent(contentEl, 'dimension');
        });
      });

      contentEl.querySelectorAll('[data-ai-dimension]').forEach(function (card) {
        card.addEventListener('click', function () {
          setAiDimension(card.getAttribute('data-ai-dimension'));
          closeStepPopup();
        });
      });
    }

    if (type === 'style') {
      contentEl.querySelectorAll('[data-ai-style]').forEach(function (card) {
        card.addEventListener('click', function () {
          setAiStyle(card.getAttribute('data-ai-style'));
          closeStepPopup();
        });
      });
    }
  }

  function initStepPopupChips() {
    var summaryChips = document.querySelectorAll('.ai-summary-row .ai-summary-chip');
    summaryChips.forEach(function (chip) {
      var labelEl = chip.querySelector('.ai-summary-chip-label');
      if (!labelEl) {
        return;
      }

      var labelText = labelEl.textContent.trim().toLowerCase();
      var popupType = labelText === 'dimension' ? 'dimension' : (labelText === 'style' ? 'style' : null);

      if (!popupType) {
        return;
      }

      chip.classList.add('ai-summary-chip--clickable');
      chip.setAttribute('role', 'button');
      chip.setAttribute('tabindex', '0');
      chip.setAttribute('aria-label', 'Edit ' + labelText + ' selection');

      var valueEl = chip.querySelector('.ai-summary-chip-value');
      if (valueEl) {
        var editIcon = document.createElement('svg');
        editIcon.setAttribute('class', 'ai-summary-chip-edit-icon');
        editIcon.setAttribute('width', '11');
        editIcon.setAttribute('height', '11');
        editIcon.setAttribute('viewBox', '0 0 24 24');
        editIcon.setAttribute('fill', 'none');
        editIcon.setAttribute('stroke', 'rgba(192,132,252,0.8)');
        editIcon.setAttribute('stroke-width', '2.2');
        editIcon.setAttribute('stroke-linecap', 'round');
        editIcon.setAttribute('stroke-linejoin', 'round');
        editIcon.innerHTML = '<path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>';
        valueEl.appendChild(editIcon);
      }

      var type = popupType;
      chip.addEventListener('click', function () {
        openStepPopup(type);
      });
      chip.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openStepPopup(type);
        }
      });
    });
  }

  /* tweaks panel */
  function setAccent(color) {
    document.documentElement.style.setProperty('--blue', color);
    document.documentElement.style.setProperty('--accent', color);
  }

  /* edit-mode messaging */
  window.addEventListener('message', function (e) {
    var panel = document.getElementById('tweaksPanel');
    if (!panel || !e.data) {
      return;
    }
    if (e.data.type === '__activate_edit_mode') {
      panel.style.display = 'block';
    }
    if (e.data.type === '__deactivate_edit_mode') {
      panel.style.display = 'none';
    }
  });

  try {
    window.parent.postMessage({ type: '__edit_mode_available' }, '*');
  } catch (error) {}

  /* expose to global scope */
  window.selectThumb = selectThumb;
  window.selectStyle = selectStyle;
  window.selectOption = selectOption;
  window.removeUpload = removeUpload;
  window.setPreset = setPreset;
  window.handleCTA = handleCTA;
  window.handleCTA1 = handleCTA1;
  window.setAccent = setAccent;
})();
